export const addExistingItemQuantity = (items, existingItem) => items.map((item) => {
    const adjustment = item === existingItem ? 1 : 0;
    return {
        ...item,
        quantity: item.quantity + adjustment,
    };
});
